"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vehicle = void 0;
/* eslint-disable no-underscore-dangle */
const core_1 = require("@angular/core");
const enums_1 = require("../../../@shared-types/vehicle/enums");
const api_1 = require("../../services/api");
let Vehicle = class Vehicle {
    constructor(api) {
        this.api = api;
        this.onlineCheck = (vehicleId, dummyVehicle, newPkwEnvkvCheck) => {
            let url = `/api/vehicles/check/${vehicleId}`;
            if (newPkwEnvkvCheck) {
                url += '?newPkwEnvkvCheck=true';
            }
            return this
                .api.post(url, { dummyVehicle });
        };
        /** Returns a valid `AutoboardVehicle` with example data. */
        this.getExampleVehicle = () => {
            const vehicle = this.newVehicle();
            const { modelData, vehicleData } = vehicle;
            if (modelData) {
                modelData.make = 'Jeep';
                modelData.model = 'Grand Cherokee';
                modelData.modelDescription = 'Summit Reserve';
            }
            vehicle.vin = '1C4RJFDJ1LP420036';
            vehicleData.mileage.total = 12362;
            vehicleData.registration.firstRegistration = new Date();
            vehicleData.registration.licence = 'HH AB 289';
            return vehicle;
        };
    }
    getAll(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            // console.time('Vehicle get');
            // console.timeLog('Vehicle get', 'start');
            const query = filter ? `?filter=${JSON.stringify(filter)}` : '';
            return this.api.get(`/api/vehicles/vehicles${query}`);
            // const results = await this.api.get<AutoboardVehicle[]>(`/api/vehicles/vehicles${query}`);
            // console.timeEnd('Vehicle get');
            return results;
        });
    }
    get(vehicleId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.get(`/api/vehicles/vehicles/${vehicleId}`);
        });
    }
    /** Updates an existing vehicle. */
    put(vehicle) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.put('/api/vehicles/vehicle', { vehicle, force: false });
        });
    }
    /** Inserts a new vehicle. Returns the id. */
    post(vehicle) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.post('/api/vehicles/vehicle', vehicle).then((res) => res._id);
        });
    }
    /** Inserts a new dummy vehicle. Returns the id. */
    postDummyVehicle(req) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.post('/api/vehicles/dummy-vehicle', req);
        });
    }
    getDummyVehicle(vehicleId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.get(`/api/vehicles/dummy-vehicle/${vehicleId}`);
        });
    }
    delete(vehicleId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.delete(`/api/vehicles/vehicle/${vehicleId}`);
        });
    }
    regenerateImages(vehicleId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.get(`/api/vehicles/image-regen/${vehicleId}`);
        });
    }
    /** Returns an empty vehicle with minium required attributes set */
    newVehicle() {
        const vehicle = {
            vin: '',
            overwriteProtection: true,
            modelData: {
                manufacturer: enums_1.EVehicleManufacturer.OTHER,
                type: {},
                assistance: {
                    parking: {},
                },
                comfort: {},
                engine: {
                    fuel: {},
                    transmission: {},
                },
                environment: {},
                features: {},
                generalDetails: {},
                infotainment: {},
                packets: {},
                safety: {},
                sport: {},
                make: '',
                model: '',
                modelDescription: '',
                modelyear: null,
            },
            vehicleData: {
                mileage: {},
                availability: {
                    code: enums_1.EAvailabilityCode.Available,
                },
                condition: {},
                costs: {},
                features: {},
                inventory: {},
                order: {},
                price: {
                    retailPrices: {},
                },
                production: {},
                registration: {},
                previousOwner: {},
                emissions: {
                    co2: {},
                    electricReach: {},
                    energyConsumption: {},
                    fuelConsumption: {},
                },
            },
        };
        return vehicle;
    }
};
Vehicle = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [typeof (_a = typeof api_1.ApiService !== "undefined" && api_1.ApiService) === "function" ? _a : Object])
], Vehicle);
exports.Vehicle = Vehicle;
